module.exports = __webpack_public_path__ + "static/backgound-mobile-menu-e82188412fe640aa59770ced14f7ab4c.svg";